import { migrateLegacyColumnWidths } from '@/utils/warehouseTableHelpers'

export const WAREHOUSE_LEDGER_PAGE_KEY = 'warehouse-ledger'

export const WAREHOUSE_LEDGER_COLUMN_KEYS = [
  'status',
  'bk_txn_id',
  'bs_log_id',
  'txn_date',
  'bk_sku',
  'linked_invoice',
  'order_number',
  'kind',
  'store',
  'signed_cases',
  'balance',
  'unit_cost',
  'shipping_alloc',
  'pick_fee_alloc',
  'receiving_alloc',
  'notes',
] as const

export const WAREHOUSE_LEDGER_DEFAULT_WIDTHS: Record<string, number> = {
  status: 108,
  bk_txn_id: 96,
  bs_log_id: 72,
  txn_date: 120,
  bk_sku: 88,
  linked_invoice: 120,
  order_number: 96,
  kind: 140,
  store: 120,
  signed_cases: 88,
  balance: 88,
  unit_cost: 96,
  shipping_alloc: 96,
  pick_fee_alloc: 96,
  receiving_alloc: 96,
  notes: 160,
}

export const WAREHOUSE_LEDGER_PINNED_COLUMNS = [
  'status',
  'bk_txn_id',
  'bs_log_id',
  'txn_date',
  'bk_sku',
] as const

export const WAREHOUSE_LEDGER_PINNED_DIVIDER_KEY = 'bk_sku'

export const LEGACY_WIDTH_KEYS = ['warehouse-ledger-cols-v2'] as const

export function migrateWarehouseLedgerColumnWidths(): void {
  migrateLegacyColumnWidths(
    WAREHOUSE_LEDGER_PAGE_KEY,
    LEGACY_WIDTH_KEYS,
    WAREHOUSE_LEDGER_COLUMN_KEYS
  )
}

export function isPinnedLedgerColumn(columnKey: string): boolean {
  return WAREHOUSE_LEDGER_PINNED_COLUMNS.includes(
    columnKey as (typeof WAREHOUSE_LEDGER_PINNED_COLUMNS)[number]
  )
}

export function pinnedLedgerHeaderClass(columnKey: string): string {
  if (!isPinnedLedgerColumn(columnKey)) return ''
  const classes = ['table-sticky-pinned', 'table-sticky-cell']
  if (columnKey === WAREHOUSE_LEDGER_PINNED_DIVIDER_KEY) classes.push('table-locked-edge')
  return classes.join(' ')
}

export function pinnedLedgerCellClass(columnKey: string): string {
  if (!isPinnedLedgerColumn(columnKey)) return ''
  const classes = ['table-sticky-pinned', 'table-sticky-cell']
  if (columnKey === WAREHOUSE_LEDGER_PINNED_DIVIDER_KEY) classes.push('table-locked-edge')
  return classes.join(' ')
}
